<div class="formulas-container">
    <!-- Banner informativo -->
    <app-alert-card type="info" title="Catálogo de Fórmulas Padrão">
        Fórmulas base do motor fiscal para cálculo tributário. ICMS, IPI, PIS, COFINS, ISSQN,
        Importação, Simples Nacional e Totais. Fórmulas de IBS/CBS (Reforma Tributária) e DIFAL
        estarão disponíveis nas telas específicas.
    </app-alert-card>

    <!-- Pesquisa -->
    <div class="formulas-search-row">
        <mat-form-field appearance="outline" class="formulas-search-field">
            <mat-label>Pesquisar fórmulas</mat-label>
            <input matInput [(ngModel)]="pesquisa" (ngModelChange)="filtrar()" placeholder="Nome, tag XML, CST...">
            @if (pesquisa) {
            <button mat-icon-button matSuffix (click)="limparPesquisa()" aria-label="Limpar">
                <mat-icon>close</mat-icon>
            </button>
            } @else {
            <mat-icon matSuffix>search</mat-icon>
            }
        </mat-form-field>
    </div>

    @if (isLoading) {
    <div class="formulas-skeleton">
        @for (panel of [1, 2, 3]; track panel) {
        <div class="skeleton-panel">
            <!-- Cabeçalho do painel de expansão -->
            <div class="skeleton-panel-header">
                <app-loading-box height="18" width="200" marginTop="0"></app-loading-box>
                <app-loading-box height="22" width="80" marginTop="0"></app-loading-box>
            </div>
            <!-- Cards de fórmula dentro do painel -->
            <div class="skeleton-cards">
                @for (card of [1, 2]; track card) {
                <div class="skeleton-card">
                    <div class="skeleton-card-header">
                        <app-loading-box height="20" width="70" marginTop="0"></app-loading-box>
                        <app-loading-box height="20" width="120" marginTop="0"></app-loading-box>
                    </div>
                    <app-loading-box height="16" width="260" marginTop="10"></app-loading-box>
                    <app-loading-box height="14" width="340" marginTop="8"></app-loading-box>
                    <app-loading-box height="48" width="0" marginTop="10"></app-loading-box>
                </div>
                }
            </div>
        </div>
        }
    </div>
    } @else if (gruposFiltrados.length === 0) {
    <app-empty-list
        [title]="'Nenhuma fórmula encontrada'"
        [subTitle]="'Ajuste os filtros de busca para visualizar as fórmulas.'">
    </app-empty-list>
    } @else {

    <mat-tab-group class="escopo-tabs" appTabsScroll [mat-stretch-tabs]="false" [disablePagination]="true">
        @for (grupo of gruposFiltrados; track grupo.chave) {
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="material-symbols-outlined tab-icon">{{iconeGrupo(grupo)}}</mat-icon>
                <span class="tab-label-text">{{grupo.grupo}}</span>
            </ng-template>
            @if (!possuiFormulas(grupo)) {
            <app-empty-state
                icon="receipt_long"
                [title]="'Nenhuma fórmula de ' + grupo.grupo + ' cadastrada'"
                subtitle="As fórmulas serão exibidas aqui quando forem disponibilizadas no catálogo.">
            </app-empty-state>
            } @else {
            <app-formula-grupo
                [grupo]="grupo"
                [permitirAlteracaoModeloEmpresa]="true"
                (modeloEmpresaSelecionado)="modeloEmpresaSelecionado.emit($event)">
            </app-formula-grupo>
            }
        </mat-tab>
        }
    </mat-tab-group>

    }
</div>
